export const mapContainerStyle = {
  width: "100%",
  height: "77vh",
};

export const mapOptions = {
  disableDefaultUI: false,
  zoomControl: true,
  scrollwheel: true,
};

export const searchOptions = [
  {
    label: "Patient",
    value: 1,
  },
  {
    label: "Location",
    value: 2,
  },
];

export const searchOptionsModal = [
  {
    label: "Patient",
    value: 1,
  },
  {
    label: "Provider",
    value: 2,
  },
];
